import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "./Reveal";
import { scrollToId } from "@/lib/api";

const LINKS = [
    { label: "The Indicator", href: "#how" },
    { label: "In Action", href: "#demo" },
    { label: "Access", href: "#steps" },
    { label: "Pricing", href: "#pricing" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={`fixed inset-x-0 top-0 z-50 border-b transition-shadow duration-300 ${
                scrolled ? "border-slate-200/80 bg-white/85 shadow-[0_8px_30px_-12px_rgba(15,23,42,0.12)] backdrop-blur-xl" : "border-transparent bg-white/60 backdrop-blur-md"
            }`}
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
                <Link to="/" data-testid="nav-logo-link" aria-label="ITF home">
                    <Logo />
                </Link>
                <nav className="hidden items-center gap-7 lg:flex">
                    {LINKS.map((l) => (
                        <button
                            key={l.href}
                            data-testid={`nav-link-${l.href.slice(1)}`}
                            onClick={() => scrollToId(l.href)}
                            className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-slate-900"
                        >
                            {l.label}
                        </button>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <Link
                        to="/checkout"
                        data-testid="nav-checkout-cta-button"
                        className="group flex items-center gap-1.5 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:scale-[1.03] hover:bg-slate-800 hover:shadow-lg active:scale-[0.98]"
                    >
                        Get ITF — $275/yr
                        <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
                    </Link>
                </div>
            </div>
        </header>
    );
}
